import { ERROR, SUCCESS } from '../actions/AsyncActions'

function initialState() {
  return {
    error: {},
    success: {},
  }
}

export default function errorReducer(state = initialState(), action) {
  switch (action.type) {
    case ERROR:
      return state ? { ...state, error: action.payload } : { error: action.payload }
    case SUCCESS:
      return state ? { ...state, success: action.payload } : { success: action.payload }
    default:
      return state
  }
}
